<template>
      <div class="nvc-info max-content">
		<top title="专家信息" :color="color"></top>
              <div class="flex">
                  <img src="//cdn.edstatic.com/203012120000/d4a570669a61b895bf4a4506eae8161e/2026/10/93511f2c-c1c9-4fb4-a7b9-0c1f8b821d86.webp" @click="getButtonData(5028)" />
                  <img src="//cdn.edstatic.com/203012120000/84d55d7ad9670563f4a494a61e420fc9/2026/10/b62b78a2-4eb5-4d49-8115-7d920a507629.webp" @click="getButtonData(5029)" alt="">
              </div>
          </div>
  </template>
  
  <script>
import {ButtonDetail} from '../../../config/interface.js'
  import Top from '../../VascularSystem/components/Top.vue'
	export default{
		components: {
    		Top
  		},    data() {
		return {
			meetingButton: [],    //会议按钮
			meeting_id: this.$route.query.meeting_id || '698',
            color:"rgb(74, 134, 232)"
		}
	},
      created(){
    
      },
       methods:{
              //获取按钮信息
              getButtonData(bid){
                  if(bid){
                      const url=ButtonDetail;
                      let params={
                          button_id:bid
                      }
                      const method="POST";
                      fetch(url,params,method)
                      .then((res)=>{
                          if(res.code==0){
                            this.$router.push(res.data.url);
                          }
                      })
  
                  }
              },

      }
  }
  </script>
  
  <style scoped>
  /* .bg{
      background: white;
  } */
  .nvc-info{
    width: 100%;
      position: relative;
  }
  .nvc-info img{
      width: 100%;
  }

  .nvc-info .text{
      margin: 10px 0 30px;
      font-size: 13px;
      line-height: 26px;
  }
  .nvc-info .line1{
      line-height: 40px;
  }
  .nvc-info .line1 img{
      width: 20px;
      vertical-align: middle;
      line-height: 40px;
      margin-right: 10px;
  }
  .nvc-info .flex{
      width: 100%;
      padding: 20px 10%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
  }
  .nvc-info .flex img{
      width: 43%;
      margin-bottom: 10px;
  }
  .wel-text{
      background-color: #C23231;
      color: white;
      font-size: 13px;
      line-height: 30px;
  }
  .speaker-words{
      position: relative;
      font-size: 13px;
  }
  .speaker-words .bottom-icon{
      position: absolute;
      right: 0;
      width: 40px;
  }
  .text-flex{
      margin: 30px 0 20px;
  }
  .text-flex img{
      width: 29%;
      float: left;
      margin-right: 10px;
  }
  .bottom-img{
      width: 100%;
      display: block;
  }
  </style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting698/download.vue